<template>
    <div>
        <button @click="toggleDropDown(!open)" type="button" class="pro-nav__mobile-section-button" :class="{ 'pro-nav__mobile-section-button--active': open }">
            {{ label }} <ProIcon icon="cta-right" />
        </button>
        <TransitionHeight>
            <div v-show="open">
                <ul class="pro-nav__mobile-sub-menu">
                    <li v-for="(item, x) in list" :key="x" class="pro-nav__mobile-item">
                        <ProLink :href="item.href ? item.href : null" :to="item.name ? { name: item.name } : null" :target="item.external ? '_blank' : null"
                            >{{ item.title }}<ProIcon v-if="item.external" icon="external"
                        /></ProLink>
                    </li>
                </ul>
            </div>
        </TransitionHeight>
    </div>
</template>

<script>
import TransitionHeight from "~/components/TransitionHeight";

export default {
    components: {
        TransitionHeight,
    },
    props: {
        label: {
            type: String,
            required: true,
        },
        list: {
            type: Array,
            required: true,
        },
    },
    data: () => {
        return {
            open: false,
        };
    },

    methods: {
        toggleDropDown(state) {
            this.open = state;
        },
    },
};
</script>
